import {
  ESTADO_REVISION_DOCUMENTO_COMERCIAL,
  EstadoRevisionDocumentoComercialType,
} from "api/Types/EstadoRevisionDocumentoComercial"
import { ESTADOS_COBRO, EstadosCobroType } from "api/Types/EstadosCobro"
import { ESTADOS_PAGO, EstadosPagoType } from "api/Types/EstadosPago"

export const handleImportRedirect = (
  key: $TSMigrationFixMe,
  history: $TSMigrationFixMe
) => {
  history.push(key)
}

export const INITIAL_PRE_DATA = {
  amount: {
    min: 0,
    max: 1000,
  },
  estadoDePago: {
    NoPagado: false,
    Pagado: false,
    ParcialmentePagado: false,
  },
  estadoRevision: {
    Pendiente: false,
    Validado: false,
    Rechazado: false,
  },
  date: {
    min: "dd-mm-aaaa",
    max: "dd-mm-aaaa",
  },
}

export const INITIAL_PRE_DATA_FAC = {
  amount: {
    min: 0,
    max: 1000,
  },
  estadoDePago: {
    NoPagado: false,
    Pagado: false,
    ParcialmentePagado: false,
  },
  estadoRevision: {
    Pendiente: false,
    Validado: false,
    Rechazado: false,
    Eliminado: false,
  },
  date: {
    min: "dd-mm-aaaa",
    max: "dd-mm-aaaa",
  },
}

export const ESTADO_REVISION_DEFAULT: Record<
  EstadoRevisionDocumentoComercialType,
  boolean
> = {
  [ESTADO_REVISION_DOCUMENTO_COMERCIAL.PENDIENTE]: false,
  [ESTADO_REVISION_DOCUMENTO_COMERCIAL.VALIDADO]: false,
  [ESTADO_REVISION_DOCUMENTO_COMERCIAL.RECHAZADO]: false,
  [ESTADO_REVISION_DOCUMENTO_COMERCIAL.ELIMINADO]: false,
  [ESTADO_REVISION_DOCUMENTO_COMERCIAL.BORRADOR]: false,
}

export const ESTADO_COBRO_DEFAULT: Record<EstadosCobroType, boolean> = {
  [ESTADOS_COBRO.NO_COBRADO]: false,
  [ESTADOS_COBRO.PARCIALMENTE_COBRADA]: false,
  [ESTADOS_COBRO.COBRADO]: false,
}

export const ESTADO_PAGO_DEFAULT: Record<EstadosPagoType, boolean> = {
  [ESTADOS_PAGO.NO_PAGADO]: false,
  [ESTADOS_PAGO.PARCIALMENTE_PAGADA]: false,
  [ESTADOS_PAGO.PAGADA]: false,
}
